import { config } from '@uhg-abyss/web/tools/config';
import {
  unitedHealthOneSSORequest,
  paanSSOTokenRequest,
  paanDetailsSSOTokenRequest,
  mbmSSOTokenRequest,
} from './requests';

import { getUserDetailsRequest } from '../user/requests';

const ssoRequest = (payload) => {
  if (payload) {
    const { partner, target, token } = payload;
    const url = config('PING_FEDERATE_SSO_URL');
    const formEl = document.createElement('form');
    document.body.appendChild(formEl);
    formEl.action = `${url}?PARTNER=${partner}&TARGET=${target}&opentoken=${token}`;
    formEl.method = 'POST';
    formEl.submit();
  }
};

export const ssoSaga = async ({ action }) => {
  const user = await getUserDetailsRequest();
  let payload;

  if (
    [
      'uhone-claims',
      'uhone-Claim search',
      'uhone-CRP',
      'uhone-Search PRA',
      'uhone-Claim submission',
      'uhone-eligibility',
    ].includes(action.payload.sso)
  ) {
    payload = await unitedHealthOneSSORequest({
      ...action.payload,
      user,
    });
  }

  if (['paan'].includes(action.payload.sso)) {
    payload = await paanSSOTokenRequest({
      ...action.payload,
      user,
    });
  }

  if (['mbm'].includes(action.payload.sso)) {
    payload = await mbmSSOTokenRequest({
      ...action.payload,
      user,
    });
  }

  if (['paan-case-details'].includes(action.payload.sso)) {
    payload = await paanDetailsSSOTokenRequest({
      ...action.payload,
      user,
    });
  }

  ssoRequest(payload);
};
